import Link from '@components/common/Link/Link'
import FishLogo from '@components/icons/FishLogo'
import Button from '@components/ui/ButtonV2/Button'
import Cross from '@components/ui/Icons/Cross/Cross'
import Number from '@components/ui/Number/Number'
import { useCart } from '@features/cart/api/get-cart'
import { formatPriceV2 } from '@lib/format-price'
import { selectAlpha2Code, selectLabels } from '@redux/globalSlice'
import { mapEdgesToItems } from '@utils/map'
import clsx from 'clsx'
import { FC, LegacyRef, forwardRef, useEffect, useRef, useState } from 'react'
import mergeRefs from 'react-merge-refs'
import { useDispatch, useSelector } from 'react-redux'
import CartItem from '../CartItem/CartItem'
import s from '../Navbar.module.scss'
export interface CartPreviewProps {
  ref?: LegacyRef<HTMLFormElement>
  closePreviewCart: () => void
}
const CartPreview: FC<CartPreviewProps> = forwardRef(
  ({ closePreviewCart }, ref) => {
    const [loading, setLoading] = useState(false)
    const cartPreviewCheckout = useRef<HTMLDivElement>(null)
    const cartPreview = useRef<HTMLFormElement>(null)

    const { data: cart } = useCart()
    const totalItems = cart?.lineItemsQuantity
    const labels = useSelector(selectLabels)
    const alpha2Code = useSelector(selectAlpha2Code)

    const dispatch = useDispatch()

    useEffect(() => {
      if (cartPreviewCheckout.current) {
        const cartPreviewHeight = getComputedStyle(
          cartPreviewCheckout.current,
        ).height
        cartPreview.current.style.setProperty(
          '--cart-checkout-height',
          `${cartPreviewHeight}`,
        )
        //Get the height of cart preview
      } else {
        cartPreview.current.style.setProperty(
          '--cart-checkout-height',
          `${0}px`,
        )
      }
    }, [cartPreviewCheckout.current, totalItems])

    return (
      <form
        className={clsx(s.cartPreview)}
        // onSubmit={handleSubmit}
        ref={mergeRefs([cartPreview, ref])}
      >
        <div className={s.cartPreviewContainer}>
          <button
            className={s.cartPreviewClose}
            type={'button'}
            onClick={closePreviewCart}
          >
            <Cross width={16} height={16} />
          </button>
          <div className={s.cartPreviewContentWrapper}>
            {totalItems > 0 ? (
              <>
                <h3 className={s.cartPreviewHeading}>
                  YOU HAVE {totalItems} {totalItems > 1 ? 'ITEMS' : 'ITEM'} IN
                  YOUR BASKET
                </h3>
                <ul className={s.cartPreviewItems}>
                  {mapEdgesToItems(cart?.lineItems)?.map((line) => (
                    <CartItem key={line.id} line={line} />
                  ))}
                </ul>
              </>
            ) : (
              <div className={s.emptyCartBox}>
                <FishLogo width={50} height={50} />
                <h3 className={s.emptyCartHeading}>{labels?.emptyCartLabel}</h3>
                <Button
                  variant="secondary"
                  size="small"
                  as={Link}
                  link={labels?.emptyCartCTA}
                >
                  {labels?.emptyCartCTA?.name}
                </Button>
              </div>
            )}
          </div>

          {totalItems > 0 && (
            <div className={s.cartPreviewCheckout} ref={cartPreviewCheckout}>
              <div className={s.cartPreviewTotalContainer}>
                <div className={s.cartPreviewTotalHeadings}>
                  <span className={s.cartPreviewTotalSumHeading}>
                    {labels?.basketTotalSum}
                  </span>
                  <span className={s.cartPreviewTotalSumSubhading}>
                    {/* {cart.taxExcludedFromPrice ? '' : ' Tax incl.'} */}
                  </span>
                </div>
                <Number>{formatPriceV2(alpha2Code, cart?.total, 2)}</Number>
              </div>
              <div className={s.cartPreviewCheckoutBtnWrapper}>
                <Button
                  as={Link}
                  variant="secondary"
                  className={s.cartPreviewCheckoutBtn}
                  loading={loading}
                  link={{ url: '/cart' }}
                >
                  {labels?.basketCheckoutBtn}
                </Button>
              </div>
            </div>
          )}
        </div>
      </form>
    )
  },
)
CartPreview.displayName = 'CartPreview'
export default CartPreview
